import type { FeatureKey } from "../../utils/usePermissions";

/** Sub-item icon: SVG path, or Lucide name (rendered in Sidebar). */
export type SidebarSubItemLucide = "HeartPulse" | "RadioTower";

export type NavigationSubItem = {
  text: string;
  href: string;
  featureKey?: FeatureKey;
  textReconciliations?: string;
} & (
  | { src: string; lucide?: undefined }
  | { lucide: SidebarSubItemLucide; src?: undefined }
);

export const navigationConfig = [
  {
    src: "/sidebar/Dashboard.svg",
    text: "Dashboard",
    href: "/ledger-recon-dashboard",
    featureKey: "ledger_recon" as FeatureKey,
  },
  {
    src: "/sidebar/Recon.svg",
    text: "Reconciliations",
    href: " ",
    subItems: [
      {
        src: "/sidebar/LedgerRecon.svg",
        text: "Ledger",
        textReconciliations: "Ledger Reconciliation",
        href: "/recon?type=ledger_recon",
        featureKey: "ledger_recon" as FeatureKey,
      },
      {
        src: "/sidebar/PaymentGateway.svg",
        text: "Payment Gateway",
        textReconciliations: "Payment Gateway Reconciliation",
        href: "/recon?type=pg_recon",
        featureKey: "pg_recon" as FeatureKey,
      },
      {
        src: "/sidebar/BankRecon.svg",
        text: "Bank",
        textReconciliations: "Bank Reconciliation",
        href: "/recon?type=bank_recon",
        featureKey: "bank_recon" as FeatureKey,
      },
    ],
  },
  {
    src: "/sidebar/BalanceConfirmations.svg",
    text: "Balance Confirmation",
    href: "/balance-confirmations",
    featureKey: "balance_confirmation" as FeatureKey,
  },
  {
    src: "/sidebar/AiAnalyst.svg",
    text: "AI Analyst",
    href: "/ai-analyst",
    featureKey: "ai_analyst" as FeatureKey,
  },
  {
    src: "/sidebar/ReconPlayground.svg",
    text: "Recon Playground",
    href: "/recon-playground",
    featureKey: "debug" as FeatureKey,
  },
  {
    src: "/sidebar/MasterDataSheet.svg",
    text: "Master Datasheet",
    href: "/master-datasheet",
    featureKey: "master_data" as FeatureKey,
  },
  {
    src: "/sidebar/Admin.svg",
    text: "Admin Portal",
    href: " ",
    featureKey: "admin_portal" as FeatureKey,
    subItems: [
      {
        lucide: "HeartPulse" as const,
        text: "Pulse",
        textReconciliations: "Pulse",
        href: "/admin-portal",
        featureKey: "admin_portal" as FeatureKey,
      },
      {
        src: "/sidebar/WatchTower.svg",
        text: "Watch Tower",
        textReconciliations: "Watch Tower",
        href: "/admin-portal/review-portal",
        featureKey: "admin_portal" as FeatureKey,
      },
      {
        src: "/sidebar/UserManagement.svg",
        text: "User Management",
        textReconciliations: "User Management",
        href: "/admin-portal/users",
        featureKey: "admin_portal" as FeatureKey,
      },
      {
        lucide: "RadioTower" as const,
        text: "Beacon",
        textReconciliations: "Beacon",
        href: "/admin-portal/beacon",
        featureKey: "admin_portal" as FeatureKey,
      },
    ],
  },
  {
    src: "/sidebar/ControlCenter.svg",
    text: "Control Center",
    href: " ",
    featureKey: "control_center" as FeatureKey,
    /** Keeps the parent dropdown visible even when only one sub-item is present. */
    excludeFromCollapse: true,
    subItems: [
      {
        src: "/sidebar/ReminderSettings.svg",
        text: "Reminder Settings",
        textReconciliations: "Reminder Settings",
        href: "/control-center/reminder-settings",
        featureKey: "reminder_settings" as FeatureKey,
      },
    ],
  },
];
